module.exports = __webpack_public_path__ + "f88540af9b084b8da7be3d2b68342eca.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/glasses-pink-s.png
// module id = 1829
// module chunks = 0